import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useDropdownItem } from '@restart/ui/DropdownItem';
import Anchor from '@restart/ui/Anchor';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var DropdownItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    eventKey = _ref.eventKey,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClick = _ref.onClick,
    active = _ref.active,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? Anchor : _ref$as,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "eventKey", "disabled", "onClick", "active", "as"]);
  var prefix = useBootstrapPrefix(bsPrefix, 'dropdown-item');
  var _useDropdownItem = useDropdownItem({
      key: eventKey,
      href: props.href,
      disabled: disabled,
      onClick: onClick,
      active: active
    }),
    _useDropdownItem2 = _slicedToArray(_useDropdownItem, 2),
    dropdownItemProps = _useDropdownItem2[0],
    meta = _useDropdownItem2[1];
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, dropdownItemProps, {
    ref: ref,
    className: classNames(className, prefix, meta.isActive && 'active', disabled && 'disabled')
  }));
});
DropdownItem.displayName = 'DropdownItem';
export default DropdownItem;